const emailRegex = /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
const emailsRegex = new RegExp(`^(${emailRegex.source})([,\\s]+${emailRegex.source})*$`);

export default {
	emailRegex,
	emailsRegex,
};